import React from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { useLanguage } from "../../../contexts/LanguageContext";

const DealerWarehouseForm = ({
  dialogVisible,
  editMode,
  submitted,
  hideDialog,
  renderDialogFooter,

  warehouseName,
  relatedWarehouseId,
  warehouseTypeId,
  warehouseStyle,
  isActive,

  setWarehouseName,
  setRelatedWarehouseId,
  setWarehouseTypeId,
  setWarehouseStyle,
  setIsActive,

  typeOptions,
  parentOptions
}) => {
  const { th } = useLanguage();

  return (
    <Dialog
      visible={dialogVisible}
      style={{ width: "580px" }}
      header={editMode ? (th("dealerWarehouse.edit") || "Ambar Düzenle") : (th("dealerWarehouse.new") || "Yeni Ambar")}
      modal
      className="p-fluid"
      footer={renderDialogFooter()}
      onHide={hideDialog}
    >
      <div className="grid">
        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">{th("dealerWarehouse.warehouseName") || "Ambar Adı"}</label>
            <InputText
              value={warehouseName}
              onChange={(e) => setWarehouseName(e.target.value)}
              className={submitted && !warehouseName.trim() ? "p-invalid" : ""}
              placeholder={th("dealerWarehouse.warehouseNamePlaceholder") || "Ambar adı giriniz"}
            />
            {submitted && !warehouseName.trim() && (
              <small className="p-error">{th("dealerWarehouse.validation.nameRequired")}</small>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">{th("dealerWarehouse.parent") || "Bağlı Olduğu Ambar"}</label>
            <Dropdown
              value={relatedWarehouseId}
              onChange={(e) => setRelatedWarehouseId(e.value)}
              options={parentOptions}
              optionLabel="label"
              optionValue="value"
              placeholder={th("dealerWarehouse.parentPlaceholder") || "Ana ambar seçiniz (opsiyonel)"}
              showClear
            />
          </div>
        </div>

        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">{th("dealerWarehouse.type") || "Stok Yeri"}</label>
            <Dropdown
              value={warehouseTypeId}
              onChange={(e) => setWarehouseTypeId(e.value)}
              options={typeOptions}
              optionLabel="label"
              optionValue="value"
              className={submitted && !warehouseTypeId ? "p-invalid" : ""}
              placeholder={th("dealerWarehouse.typePlaceholder") || "Stok yeri seçiniz"}
            />
            {submitted && !warehouseTypeId && (
              <small className="p-error">{th("dealerWarehouse.validation.typeRequired")}</small>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">{th("dealerWarehouse.style") || "Türü"}</label>
            <div className="flex align-items-center gap-4">
              <div className="flex align-items-center">
                <RadioButton
                  inputId="style1"
                  name="style"
                  value={1}
                  onChange={(e) => setWarehouseStyle(e.value)}
                  checked={warehouseStyle === 1}
                />
                <label htmlFor="style1" className="ml-2">{th("dealerWarehouse.fixed")}</label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="style2"
                  name="style"
                  value={2}
                  onChange={(e) => setWarehouseStyle(e.value)}
                  checked={warehouseStyle === 2}
                />
                <label htmlFor="style2" className="ml-2">{th("dealerWarehouse.mobile")}</label>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="field-checkbox mb-2">
            <Checkbox inputId="isActive" checked={isActive} onChange={(e) => setIsActive(e.checked)} />
            <label htmlFor="isActive" className="ml-2">{th("common.active") || "Aktif"}</label>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DealerWarehouseForm;
